var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"number"},[_vm._v("404")]),_c('div',[_c('h1',[_vm._v("抱歉，这个页面无法获取")]),_c('h4',[_vm._v("你点击的链接可能发生了故障，或者您无权限访问本页面")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回上一级")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }